<div class="featured-message" aria-labelledby="featured-message-heading">
	<i class="ficon-sparkles-solid" aria-hidden="true"></i>
	<p id="featured-message-heading" class="heading" [innerHTML]="'featured-message_heading' | translate"></p>
	<p class="body" translate="featured-message_body"></p>
	<button
		class="primary-btn start-trial-btn"
		translate="featured-message_button-label"
		[attr.aria-label]="'featured-message_button-label' | translate"
		(click)="openAiTrialCourseSelectorDialog()">
	</button>
</div>
